import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BsCreditCard, BsShieldCheck } from "react-icons/bs";
import WinningBidFaqModal from "./custom/WinningBidFaqModal";
import "./Placebid.css";
// import cardIcon from "../../../public/assets/images/cardicons";
import cardIcon from "./../../../public/assets/images/cardicons/creditcardicons.png";
import secure from "./../../../public/assets/images/secure.png";

const WinningBidDepositInfo = () => {
  const [showFaqModal, setShowFaqModal] = useState(false);

  const handleFaqOpen = () => setShowFaqModal(true);
  const handleFaqClose = () => setShowFaqModal(false);
  return (
    <div
      className="p-4"
      style={{ backgroundColor: "#fffbee", borderRadius: "8px" }}
    >
      <p className="winning-bidheadddd">Bid Deposit</p>
      <p>
        For more information about the bid-cancellation process, please see our{" "}
        <a
          href="#"
          className="text-primary text-decoration-underline"
          onClick={handleFaqOpen}
        >
          FAQs
        </a>
      </p>
      <hr />
      <Row className="pt-3">
        <Col md={6} className="d-flex">
          <div className="me-3 mt-1">
            {/* <BsCreditCard size={28} /> */}
            <img src={cardIcon} alt="" size={28} />
          </div>
          <div>
            <p className="fw-bold mb-1">Why do we require a credit card?</p>
            <p className="mb-0">
              Using a major credit card ensures a serious commitment on behalf
              of the buyer and helps us maintain the integrity of our auctions.
            </p>
          </div>
        </Col>
        <Col md={6} className="d-flex mt-4 mt-md-0">
          <div className="me-3 mt-1">
            {/* <BsShieldCheck size={28} /> */}
            <img src={secure} alt="" width={40} height={25} />
          </div>
          <div>
            <p className="fw-bold mb-1">How do I know bids are valid?</p>
            <p className="mb-0">
              Hubzu will ask challenge questions with information obtained from
              public records to verify the identity of bidders.
            </p>
          </div>
        </Col>
      </Row>
      <WinningBidFaqModal show={showFaqModal} handleClose={handleFaqClose} />
    </div>
  );
};

export default WinningBidDepositInfo;
